import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form ,Offcanvas} from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const WithCreatePermission = withPermission(({ children }) => children, ['country-create']);
const WithEditPermission = withPermission(({ children }) => children, ['country-edit']);
const WithDeletePermission = withPermission(({ children }) => children, ['country-delete']);

const API_URL = `${backendUrl}/api/countries`;

const CountryDetails = () => {
    const [countries, setCountries] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
        const [errors, setErrors] = useState({});
    
const debounceTimeoutRef = useRef(null);
useEffect(() => {
    if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
        fetchCountries(1, searchQuery);
    }, searchQuery ? 1500 : 0); 

    return () => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
    };
}, [searchQuery]);
const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);

};   
    const fetchCountries = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    page: page,
                    search: searchQuery,
                },
            });
            setCountries(response.data.Data.data);
            setPageCount(response.data.Data.last_page);
            setCurrentPage(response.data.current_page);


        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const handleAddCountry = () => {
        setFormData({ name: '' });
        setIsEdit(false);
        setSelectedCountry(null);
        setShowModal(true);
    };

    const handleEditCountry = (country) => {
        setFormData(country);
        setIsEdit(true);
        setSelectedCountry(country);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
            try {
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
                await axios.delete(`${API_URL}/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setCountries(countries.filter(country => country.id !== id));
                Swal.fire(
                    "Deleted!",
                    "The country has been deleted.",
                    "success"
                );
            } catch (error) {
                console.error('Error deleting country:', error);
                Swal.fire(
                    "Error!",
                    "Failed to delete country. Please try again.",
                    "error"
                );
            }
        }
        });
        
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchCountries(newPage);
    };
    const validateForm = () => {
            const newErrors = {};
            if (!formData.name) newErrors.name = 'Name is required';
    
    
            return newErrors;
        };
        const [loading, setLoading] = useState(false);
    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedCountry.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setCountries(countries.map(ind => (ind.id === selectedCountry.id ? response.data.Data : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setCountries([...countries, response.data.Data]);
            }
            setShowModal(false);
        } catch (error) {
            console.error('Error saving country:', error);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Country</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript:void(0);">Country</a></li>
                                        <li className="breadcrumb-item active">Country List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control font-size-12"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <WithCreatePermission>
                                        <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                   
                                                    onClick={handleAddCountry}                                                     
                                                    data-bs-placement="top"
                                                    title="Add Country"
                                                >
                                                    <i className="mdi mdi-plus" ></i>
                                                </button></WithCreatePermission>
                                    </div>
                                    <div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle"> Name</th>
                                                    <th className="align-middle"> Country Code</th>

                                                    <th className="align-middle"> Phone Code</th>
                                                    <th className="align-middle"> Currency</th>
                                                    <th className="align-middle"> Tax(%)</th>


                                                    <th className="align-middle">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {countries.map((country, index) => (
                                                    <tr key={country.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instanceCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`instanceCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td>{country.name}</td>
                                                        <td>{country.iso3}</td>
                                                        <td>{country.phonecode}</td>
                                                        <td>{country.currency}</td>
                                                        <td>{country.tax}</td>


                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li><WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditCountry(country)}>
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(country.id)}>
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-end pagination-sm">
                                    <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageChange}
                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item previous'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item next'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            activeClassName={'active'}
                        />
                                    </div>
                                    {/* Modal for Add/Edit Country */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' >
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit Country' : 'Add Country'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="countryName mb-3">
                                                    <Form.Label className='form-font'>Name</Form.Label>
                                                    <Form.Control type="text" name="name" value={formData.name} onChange={handleInputChange} 
                                                     className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

                                                     />
                                                     {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}
                                                </Form.Group><br/>
                                                <Form.Group controlId="countcode mb-3">
                                                    <Form.Label className='form-font'>Country Code</Form.Label>
                                                    <Form.Control type="text" name="iso3" value={formData.iso3} onChange={handleInputChange} />
                                                </Form.Group><br/>
                                                <Form.Group controlId="phone mb-3">
                                                    <Form.Label className='form-font'>Phone Code</Form.Label>
                                                    <Form.Control type="text" name="phonecode" value={formData.phonecode} onChange={handleInputChange} />
                                                </Form.Group><br/>
                                                <Form.Group controlId="currency mb-3">
                                                    <Form.Label className='form-font'>Currency</Form.Label>
                                                    <Form.Control type="text" name="currency" value={formData.currency} onChange={handleInputChange} />
                                                </Form.Group><br/>
                                                <Form.Group controlId="tax mb-3">
                                                    <Form.Label className='form-font'>Tax</Form.Label>
                                                    <Form.Control type="number" name="tax" value={formData.tax} onChange={handleInputChange} />
                                                </Form.Group>
                                                 <Form.Group controlId="tax mb-3">
                                                    <Form.Label className='form-font'>Exchange Rate</Form.Label>
                                                    <Form.Control type="number" name="exchange_rate" value={formData.exchange_rate} onChange={handleInputChange} />
                                                </Form.Group>
                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                        <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountryDetails;
